<script>
  import WaitingFor from './WaitingFor.svelte';

  export let submit;
  let email='', hire=false, work=false, comments='';

  let submitted = false;
</script>

<h2 style="margin-bottom: 40px;">Show interest</h2>

{#if submitted}
  {#await submit(email, hire, work, comments)}
    <WaitingFor message="Submitting" style="color: #888"/>
  {:then}
    <p>Thank you! We'll keep you posted at <span style='color: #3a3'>{email}</span></p>
  {/await}
{:else}
  <form class="pure-form pure-form-stacked">
    <fieldset>
      <legend>Your Email</legend>
      <input type="email" class='pure-input' id="email" bind:value={email}/>
    </fieldset>
    <fieldset>
      <legend>How would you use Interviewless?</legend>
      <div style="margin: 0 auto; text-align: left; width: 280px;">
        <label for="use-hire" class='pure-checkbox'>
          <input type="checkbox" id="use-hire" name='use-interviewless' bind:checked={hire}/> To hire freelancers
        </label>
        <label for="use-work" class='pure-checkbox'>
          <input type="checkbox" id="use-work" name='use-interviewless' bind:checked={work}/> To be hired
        </label>
      </div>
    </fieldset>
    <fieldset>
      <legend>Comments</legend>
      <label for="comments" class='pure-checkbox'>
        <textarea id="comments" placeholder="(Optional) Comments? Ideas? Feedback? :)" maxlength={400} bind:value={comments}></textarea>
      </label>
    </fieldset>
    <button 
      type="submit" 
      class="pure-button pure-button-primary" 
      disabled={!(/\S+@\S+\.\S+/.test(email) && (hire || work))} 
      on:click={e => {e.preventDefault(); submitted=true}}
    > Submit
    </button>
  </form>
{/if}

<style>
  input[type=email] {
    text-align: center;
    margin: 0 auto;
    border-radius: 5px;
    width: 90%;
    box-shadow: none;
  }
  textarea {
    margin: 0 auto;
    border-radius: 5px;
    width: 90%;
    box-shadow: none;
  }
  button {
    background-color: var(--primary-color);
  }
  legend {
    border-bottom: none;
    font-weight: 500;
  }
  @media (min-width: 800px) {
    input[type=email] {
      width: 80%;
    }
    textarea {
      width: 80%;
    }
    fieldset {
      margin: 30px;
    }
  }
</style>